<div class="mobile-verification-sheet">
  <div class="sheet-header">
    <div class="sheet-title">
      <strong>휴대폰 번호 인증</strong>
      <p class="sheet-description">호스트 활동에 필요한 휴대폰 번호를 인증해주세요.</p>
    </div>
    <button type="button" class="close-btn" (click)="close()" aria-label="닫기">×</button>
  </div>

  <form [formGroup]="formGroup" class="sheet-body">
    <div class="phone-label-row">
      <div class="field-label">전화번호</div>
      <button *ngIf="step === 'CODE'" type="button" class="change-phone-link" (click)="editPhone()">
        다른 번호로 변경
      </button>
    </div>

    <div class="phone-row">
      <div class="country-select" [class.disabled]="isPhoneLocked">
        <button
          #countryTriggerRef
          type="button"
          class="country-trigger"
          [disabled]="isPhoneLocked"
          [attr.aria-expanded]="isCountryOpen"
          aria-haspopup="listbox"
          aria-label="국가 코드 선택"
          (click)="toggleCountryDropdown($event)"
          (keydown)="onCountryTriggerKeydown($event)"
        >
          <span class="flag">{{ selectedCountry.flag }}</span>
          <span class="dial-code">+{{ selectedCountry.dialCode }}</span>
          <span class="caret" aria-hidden="true"></span>
        </button>

        <div
          *ngIf="isCountryOpen"
          class="country-dropdown"
          [class.up]="dropdownDirection === 'up'"
          (click)="$event.stopPropagation()"
          (keydown)="onCountryDropdownKeydown($event)"
        >
          <input
            #countrySearchRef
            type="text"
            class="country-search"
            role="combobox"
            aria-expanded="true"
            aria-autocomplete="list"
            aria-controls="country-listbox"
            [attr.aria-activedescendant]="activeCountryOptionId"
            placeholder="국가 검색"
            aria-label="국가 검색"
            [value]="countrySearch"
            (input)="onCountrySearch($event)"
          />
          <p class="sr-only" role="status" aria-live="polite">{{ countryResultLabel }}</p>
          <ul id="country-listbox" class="country-options" role="listbox">
            <li
              *ngFor="let country of filteredCountries; let i = index"
              #countryOptionItem
              [id]="'country-option-' + i"
              role="option"
              [attr.aria-selected]="country.iso2 === selectedCountry.iso2"
              [class.selected]="country.iso2 === selectedCountry.iso2"
              [class.active]="i === activeCountryIndex"
              (click)="onCountrySelect(country)"
              (mouseenter)="activeCountryIndex = i"
            >
              <span class="flag">{{ country.flag }}</span>
              <span class="country-name">{{ country.name }}</span>
              <span class="dial-code">+{{ country.dialCode }}</span>
            </li>
          </ul>
          <p *ngIf="filteredCountries.length === 0" class="country-empty">검색 결과가 없습니다</p>
        </div>
      </div>

      <input
        class="phone-input"
        type="tel"
        inputmode="tel"
        autocomplete="tel-national"
        formControlName="localPhone"
        [placeholder]="phonePlaceholder"
        [readonly]="isPhoneLocked"
        (input)="onLocalPhoneInput($event)"
      />
    </div>

    <ng-container *ngIf="step === 'PHONE'">
      <button
        type="button"
        class="primary-btn"
        [disabled]="isRequesting || formGroup.controls.localPhone.invalid"
        (click)="requestCode()"
      >
        {{ isRequesting ? '발송 중...' : '인증번호 받기' }}
      </button>
    </ng-container>

    <ng-container *ngIf="step === 'CODE'">
      <div class="field-label verify-label">
        <span>인증번호</span>
        <span class="timer" [class.expired]="isTimerExpired">{{ remainTimeLabel }}</span>
      </div>
      <div class="code-cells" (click)="focusCodeInput()">
        <input
          #codeInput
          type="tel"
          inputmode="numeric"
          [attr.maxlength]="codeLength"
          autocomplete="one-time-code"
          name="one-time-code"
          class="code-hidden-input"
          [attr.aria-label]="'인증번호 ' + codeLength + '자리'"
          [value]="codeRaw"
          (input)="onCodeInput($event)"
          (focus)="onCodeFocus()"
          (blur)="onCodeBlur()"
        />
        <div
          *ngFor="let idx of codeCellIndexes"
          class="code-cell"
          [class.filled]="!!codeDigits[idx]"
          [class.focused]="focusedCellIndex === idx"
          [class.group-start]="idx > 0 && idx % codeGroupSize === 0"
        >
          {{ codeDigits[idx] }}
        </div>
      </div>

      <button
        type="button"
        class="primary-btn"
        [disabled]="isVerifying || formGroup.controls.authNumber.invalid || isTimerExpired"
        (click)="verifyCode()"
      >
        {{ isVerifying ? '확인 중...' : '인증하기' }}
      </button>

      <button type="button" class="resend-link" [disabled]="!canResend" (click)="requestCode()">
        {{ resendLabel }}
      </button>

      <p *ngIf="isTimerExpired" class="expired-message">인증 시간이 만료되었습니다. 인증번호를 다시 받아주세요.</p>
    </ng-container>
  </form>
</div>
